export class StyleManager{
    private static _$StyleTag:JQuery;
    public static StyleText:string='';

    constructor(public id:number=0)
    {

    }

    public AddStyleSet(className:string,styles:any):void
    {
        if(typeof styles['font-size']!="undefined")
            styles['line-height']=styles['font-size'];
        let previousStyle=this.GetStyle(className);
        let newStyles:string='';
        if(previousStyle==null){
            let newStyles=this.GetId(className)+"{";
            for(let styleName in styles)
            {
                if(styles[styleName]!='')
                    newStyles+=this.CreateStyleString(styleName,styles[styleName]);
            }
            newStyles+='}';
            StyleManager.StyleText+=newStyles;
        }
        else{

            newStyles=previousStyle;
            for(let styleName in styles)
            {
                let selectedStyle=new RegExp('[;\\{\\s]('+styleName+'[^;]*;)','i').exec(newStyles);

                if(selectedStyle==null&&styles[styleName]!='')
                    newStyles=newStyles.replace('}',this.CreateStyleString(styleName,styles[styleName])+'}');
                else
                    newStyles=newStyles.replace(new RegExp('([;\\{\\s])'+styleName+'[^;]*;','gi'),(styles[styleName]!=''?'$1'+this.CreateStyleString(styleName,styles[styleName]):'$1'));


            }

            StyleManager.StyleText=StyleManager.StyleText.replace(previousStyle,newStyles);
        }

        StyleManager.$Style.empty().append(StyleManager.StyleText);

    }

    public CreateStyleString(ruleName:string, ruleValue:string)
    {
        return ruleName+":"+ruleValue + ' !important;';

    }

    public GetStyleValue(className:string,ruleName:string)
    {
        let id:string=this.GetId(className);
        let regexp=new RegExp(id+'\\{([^\\}]*)}');
        let styleSetMath=regexp.exec((StyleManager.StyleText));



        if(styleSetMath==null)
            return this.PreGetProcess(ruleName,'');

        if(ruleName.indexOf('transform')==0)
            ruleName='transform';
        regexp=new RegExp('(?:^|;|\\s)'+ruleName+'[^:]*:([^;|!]*)','i');
        let styleRule=regexp.exec(styleSetMath[1]);
        if(styleRule==null)
            return this.PreGetProcess(ruleName,'');

        return this.PreGetProcess(ruleName,styleRule[1]);

    }

    public AddStyleRule(className:string,ruleName:string,value:string):void
    {

        let obj:any={};

        let rule=this.PreSetProcess({ruleName:ruleName,value:value});

        obj[rule.ruleName]=rule.value;
        this.AddStyleSet(className,obj);

    }

    public PreGetProcess(ruleName:string,value:any)
    {
        switch (ruleName)
        {
            case 'opacity':
                if(isNaN(value)||value=='')
                    return 100;
                return value*100;
            case 'transform':
                if(value.indexOf('rotate')>=0)
                {
                    let regexp=new RegExp('rotate\\(([0-9]*)deg\\)');
                    let result=regexp.exec(value);
                    if(result!=null&&result.length>1){
                        return result[1];
                    }

                }


        }
        return value.trim();
    }

    public PreSetProcess(rule:{ruleName:string,value:any})
    {
        switch (rule.ruleName)
        {
            case 'opacity':
                rule.value=rule.value.replace('px','')/100;
                break;
            case 'transform-rotate':
                rule.ruleName='transform';
                let value=rule.value.replace('px','');
                rule.value='rotate('+value+'deg)';
                break;
        }
        return rule;
    }




    public GetStyle(className:string):string
    {
        let elementStylesRegexp=new RegExp(this.GetId(className)+'\\{([^\\}]*)}','i');
        let match=elementStylesRegexp.exec(StyleManager.StyleText);
        if(match==null||match.length<2)
        {
            return null;
        }
        return match[0];
    }

    public GetId(className:string):string
    {
        let classSplit=className.split(',');
        let classNameToReturn='';
        for(let i=0;i<classSplit.length;i++)
            classNameToReturn+=(i!=0?',':'')+(this.id!=0?".pdfField_"+this.id+' ':'')+classSplit[i];

        return classNameToReturn;
    }





    public static get $Style():JQuery{
        if(StyleManager._$StyleTag==null)
        {
            StyleManager._$StyleTag=jQuery(`<style type="text/css"></style>`);
            jQuery('body').append(StyleManager._$StyleTag);
        }
        return StyleManager._$StyleTag;
    }


    public static GetStylesText():string{
        if(StyleManager._$StyleTag==null)
            return '';
        return '<style type="text/css">'+StyleManager.StyleText+'</style>';

    }

    public CreateStyleClassManager(className:string):StyleClassManager{
        return new StyleClassManager(this,className);
    }


    ClearFieldStyles() {
        let elementStylesRegexp=new RegExp(this.GetId('')+'[^\\{]*\\{([^\\}]*)}','i');
        let match;
        while(match=elementStylesRegexp.exec(StyleManager.StyleText)){

            StyleManager.StyleText=StyleManager.StyleText.replace(match[0],'');
            elementStylesRegexp.lastIndex=-1;
        }
        StyleManager.$Style.empty().append(StyleManager.StyleText);
    }

    static SetStyle(styles: string) {
        StyleManager.StyleText=styles;
        StyleManager.$Style.empty().text(styles);
    }

    static DuplicateStyle(originalId: number, newId: number) {
        let regex=new RegExp(`.pdfField_${originalId}[^\\{]*\\{[^\\}]*\\}`,'g');
        let matches=StyleManager.StyleText.match(regex);
        for(let currentMatch of matches)
        {
            StyleManager.StyleText+=currentMatch.replace(`.pdfField_${originalId}`,`.pdfField_${newId}`)
        }

        StyleManager.$Style.empty().append(StyleManager.StyleText);
    }
}

export class StyleClassManager
{
    constructor(public styleManager:StyleManager, public className:string)
    {

    }

    public SetValue(ruleName:string,value:string)
    {
        this.styleManager.AddStyleRule(this.className,ruleName,value);
    }

    public GetValue(ruleName)
    {
        return this.styleManager.GetStyleValue(this.className,ruleName);
    }
}